class MegaMenuHover {
  constructor() {
    this.menus = document.querySelectorAll('.mega-menu--has-panel');
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = 350;
    this.closeTimers = new Map();
    this.closeAllMenus();
    this.bindEvents();
  }

  bindEvents() {
    this.menus.forEach((menu) => {
      const panel = menu.querySelector('.mega-menu__content');

      menu.addEventListener('mouseenter', () => this.openMenu(menu));
      menu.addEventListener('mouseleave', () => this.scheduleClose(menu));

      if (panel) {
        panel.addEventListener('mouseenter', () => this.openMenu(menu));
        panel.addEventListener('mouseleave', () => this.scheduleClose(menu));
      }

      menu.addEventListener('focusin', () => this.openMenu(menu));
      menu.addEventListener('focusout', (event) => {
        const related = event.relatedTarget;
        if (related && (menu.contains(related) || panel?.contains(related))) return;
        this.scheduleClose(menu);
      });

      if (panel) {
        panel.addEventListener('focusin', () => this.openMenu(menu));
      }
    });

    window.addEventListener(
      'scroll',
      () => {
        this.closeAllMenus();
      },
      { passive: true }
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllMenus();
      }
    });
  }

  openMenu(menu) {
    this.cancelClose(menu);
    this.closeAllMenus(menu);
    menu.classList.add('mega-menu--open');
    const panel = menu.querySelector('.mega-menu__content');
    if (panel) panel.removeAttribute('hidden');
    this.setTriggerExpanded(menu, true);
    this.setHeaderPosition();
  }

  scheduleClose(menu) {
    this.cancelClose(menu);
    const timer = window.setTimeout(() => {
      this.closeMenu(menu);
      this.closeTimers.delete(menu);
    }, this.closeDelay);
    this.closeTimers.set(menu, timer);
  }

  cancelClose(menu) {
    const timer = this.closeTimers.get(menu);
    if (timer) {
      window.clearTimeout(timer);
      this.closeTimers.delete(menu);
    }
  }

  closeMenu(menu) {
    this.cancelClose(menu);
    menu.classList.remove('mega-menu--open');
    const panel = menu.querySelector('.mega-menu__content');
    if (panel) panel.setAttribute('hidden', '');
    this.setTriggerExpanded(menu, false);
  }

  closeAllMenus(exceptMenu = null) {
    this.menus.forEach((menu) => {
      if (menu !== exceptMenu) {
        this.closeMenu(menu);
      }
    });
  }

  setTriggerExpanded(menu, isExpanded) {
    const trigger = menu.querySelector('.mega-menu__trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }

  setHeaderPosition() {
    if (!this.header) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MegaMenuHover());
} else {
  new MegaMenuHover();
}
